// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_gm-0";
export var actionModalContentContainer = "_gm-1";
export var createTagButton = "_gm-2";
export var footerContainer = "_gm-7";
export var fullWidthDivider = "_gm-3";
export var hasCreateTagButton = "_gm-4";
export var noCreateTagButton = "_gm-5";
export var tagsContainer = "_gm-6";
export var tagsModalContentContainer = "_gm-8";